<template>
  <div>
    <div class="md:py-8 lg:py-8 py-2">
      <p
        class="text-black font-semibold lg:text-2xl md:text-2xl text-2xl w-full"
      >
        About Me
      </p>
      <div class="mt-2">
        <p
          class="font-normal text-md cust-fontstyle"
          v-html="userDetails.aboutMe"
        ></p>

        <!-- <p class="font-normal text-md pt-2">
          This is the most comprehensive, yet straight-forward, course for the
          Python programming language! Whether you have never programmed before,
          already know basic syntax, or want to learn about the advanced
          features of Python, this course is for you! In this course we will
          teach you Python 3.
        </p>

        <p class="font-normal text-md pt-2">
          With over 100 lectures and more than 21 hours of video this
          comprehensive course leaves no stone unturned! This course includes
          quizzes, tests, coding exercises and homework assignments as well as 3
          major projects to create a Python project portfolio!
        </p> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    userDetails: Object
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapState("auth", ["userData"])
  }
};
</script>

<style>
ul.bullet {
  list-style-type: square;
}
.cust-fontstyle > * {
  font-weight: 400;
}
.cust-fontstyle > ol {
  font-weight: 400;
  list-style-type: decimal;
}
.cust-fontstyle > ul {
  font-weight: 400;
  list-style-type: square;
}
</style>
